<template>
  <div class="picker" @click="outerClick">
    <nav class="picker__tab">
      <span @click="selectTab" class="picker__tab-link" data-pick-type="industry">業種</span>
      <span @click="selectTab" class="picker__tab-link" data-pick-type="area">エリア</span>
    </nav>
    <div class="picker__item">
      <div class="pick is-industry" data-pick-type="industry">
        <div class="pick__scroll">
          <div class="pick__round-ttl">
            <p class="pick__ttl">業種</p>
          </div>
          <div class="pick__round-top">
            <button
                @click="clearPickItems"
                type="button"
                class="pick__clear">業種指定をクリア
            </button>
          </div>
          <div
              v-for="(industry,index) in search_options.industries"
              class="pick__wrap"
          >
            <div @click="toggleChildren" class="pick__square">
              <input
                  :id="'industry_parent'+index"
                  :data-index="index"
                  class="pick__checkbox is-parent"
                  type="checkbox"
                  value=""
                  @change="changeParent"
              >
              <label
                  class="pick__label"
                  :for="'industry_parent'+index">{{ industry.industry_name }}</label>
            </div>
            <div class="pick__group">
              <div v-for="child in industry.children" class="pick__box">
                <input
                    type="checkbox"
                    :id="'industry'+child.sub_industry_id"
                    :data-index="index"
                    :value="child.sub_industry_id"
                    v-model="searchStore.sub_industry_id"
                    class="pick__checkbox is-child"
                    @change="initParent"
                >
                <label
                    :for="'industry'+child.sub_industry_id"
                    class="pick__label-s">{{ child.sub_industry_name }}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="pick__round-bottom">
          <button
              @click="closePicker"
              type="button"
              class="pick__decision">決定
          </button>
        </div>
      </div>
    </div>
    <div class="picker__item">
      <div class="pick is-area" data-pick-type="area">
        <div class="pick__scroll">
          <div class="pick__round-ttl">
            <p class="pick__ttl">エリア</p>
          </div>
          <div class="pick__round-top">
            <button
                @click="clearPickItems"
                type="button"
                class="pick__clear">エリア指定をクリア
            </button>
          </div>
          <div
              v-for="(area,index) in search_options.areas"
              class="pick__wrap"
          >
            <div @click="toggleChildren" class="pick__square">
              <input
                  :id="'area_parent'+index"
                  :data-index="index"
                  class="pick__checkbox is-parent"
                  type="checkbox"
                  value=""
                  @change="changeParent"
              >
              <label
                  class="pick__label"
                  :for="'area_parent'+index">{{ area.area_name }}</label>
            </div>
            <div class="pick__group">
              <div v-for="child in area.children" class="pick__box">
                <input
                    type="checkbox"
                    :id="'area'+child.prefecture_id"
                    :data-index="index"
                    :value="child.prefecture_id"
                    v-model="searchStore.prefecture_id"
                    class="pick__checkbox is-child"
                    @change="initParent"
                >
                <label
                    :for="'area'+child.prefecture_id"
                    class="pick__label-s">{{ child.prefecture_name }}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="pick__round-bottom">
          <button
              @click="closePicker"
              type="button"
              class="pick__decision"
          >決定
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import {onMounted} from "vue";
import {useSearchStore} from "../../stores/search";

const props = defineProps({
  pageData: {
    type: Object,
    required: true
  }
});

onMounted(() => {
  initParent();
  initOpen();
})

//初期データを取得設定
const pageData = props.pageData;
const search_options = pageData.search_options;
//検索条件を初期化
const searchStore = useSearchStore();

//業種/エリアの親変更の変更
const changeParent = (e) => {
  const pickerItem = e.currentTarget.closest('[data-pick-type]');
  const type = pickerItem.dataset.pickType;
  const input = e.currentTarget;
  const index = input.dataset.index;
  const children = pickerItem.querySelectorAll('.pick__checkbox.is-child[data-index="' + index + '"]');
  children.forEach((child: any) => {
    child.checked = input.checked;
  })
  if (input.checked) {
    input.closest('.pick__wrap').classList.add('is-open');
  }

  let ids = [];
  pickerItem.querySelectorAll('.pick__checkbox.is-child:checked').forEach(el=>{
    ids.push(el.value);
  })
  
  if(type=='industry'){
    searchStore.sub_industry_id = ids; 
  }
  if(type=='area'){
    searchStore.prefecture_id = ids; 
  }
  
  
}

//業種/エリアの子要素の表示/非表示
const toggleChildren = (e) => {
  e.currentTarget.closest('.pick__wrap').classList.toggle('is-open');
}

//チェックがあるものを開く
const initOpen = () => {
  const parents: any = document.querySelectorAll('.pick__checkbox.is-parent:checked');
  parents.forEach((parent) => {
    parent.closest('.pick__wrap').classList.add('is-open');
  })
}

//親業種のチェック設定
const initParent = (e?) => {
  let parents: any;
  if (e) {
    const pickerItem = e.currentTarget.closest('[data-pick-type]')
    parents = pickerItem.querySelectorAll('.pick__checkbox.is-parent');
  } else {
    parents = document.querySelectorAll('.pick__checkbox.is-parent');
  }
  parents.forEach((parent) => {
    let checked = false;
    const wrap = parent.closest('.pick__wrap');
    const index = parent.dataset.index;
    const children = wrap.querySelectorAll('.pick__checkbox.is-child[data-index="' + index + '"]');
    children.forEach((el: any) => {
      if (el.checked) {
        checked = true;
      }
    })
    parent.checked = checked;
  });
}


const clearPickItems = (e) => {
  const pickerItem = e.currentTarget.closest('[data-pick-type]')
  const type = pickerItem.dataset.pickType;
  if (type == 'industry') {
    searchStore.clearindustry();
  }
  if (type == 'area') {
    searchStore.clearArea();
  }
  pickerItem.querySelectorAll('input[type="checkbox"]:checked').forEach(el => {
    el.checked = false;
  })
  pickerItem.querySelectorAll('.pick__wrap.is-open').forEach(el => {
    el.classList.remove('is-open');
  })
}

const closePicker = () => {
  const picker = document.querySelector('.picker');
  picker.dataset.pickType = '';
}

const selectTab = (e) => {
  const type = e.currentTarget.dataset.pickType;
  const picker:any = document.querySelector('.picker');
  picker.dataset.pickType = type;
}

//エリア外をクリックで閉じる
const outerClick = (e) => {
  if(e.target.classList.contains('pick')){
    const picker:any = document.querySelector('.picker');
    picker.dataset.pickType = null;
  }
}


</script>